<template>
  <div class="jin-m-tabbar jin-m">
    <div class="jin-m-tabbar-con jin-m-container">
      <span @click="show = !show">
        <Icon name="m-menu" />
      </span>
      <img src="@/assets/logo.png" alt="">
      <div v-if="userInfo && userInfo.nick" class="jin-m-tabbar-userInfo">
        <div class="info">
          <img :src="userInfo.avatar" alt="">
        </div>
        <ul class="jin-m-tabbar-return">
          <li @click="onLogout">退出登录</li>
        </ul>
      </div>
      <span v-else class="unlogin" @click="onLogin">
        <Icon name="user" />
        登录
      </span>
    </div>
    <van-popup v-model="show" position="left" get-container="#app" :style="{ width: '200px', height: '100%' }">
      <div class="jin-m-popup">
        <span @click="show = false">
          <Icon name="close" />
        </span>
        <ul class="jin-m-popup-menu">
          <li v-for="item in tab" :key="item.name" class="jin-m-popup-menu-item" @click="clickTab(item)">
            <p>{{ item.name }}</p>
            <Icon name="arrow-right" />
          </li>
        </ul>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Popup } from 'vant'
import members from '@/utils/user'
import { mapGetters } from 'vuex'

export default {
  components: {
    [Popup.name]: Popup
  },
  data() {
    return {
      show: false,
      tab: [
        {
          url: '/',
          name: '首页'
        },
        {
          url: '/list?attributes=1',
          name: '社会招聘'
        },
        {
          url: '/list?attributes=0',
          name: '校园招聘'
        },
        {
          url: '/',
          name: '文化福利'
        },
        {
          url: '/aboutDetails/Info',
          name: '了解金十'
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'resumeList'
    ])
  },
  methods: {
    onLogin() {
      members.showLogin()
    },
    onLogout() {
      members.logout()
      // this.getInfo()
    },
    clickTab({ name, url }) {
      this.show = false
      if (name === '文化福利') {
        const welfareElTop = document.querySelector('.srcoll-el').getBoundingClientRect().top
        this.$router.push(url)
        setTimeout(() => window.scrollTo(0, welfareElTop - 30), 200)
      } else {
        this.$router.push(url)
      }
    }
  }
}
</script>

<style lang="scss">
.jin {
  &-m {
    &-tabbar {
      background: #4777f4;

      &-con {
        height: 43px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;

        i {
          cursor: pointer;
          font-size: 24px;
          color: #fff;
        }

        .unlogin {
          display: flex;
          align-items: center;
          color: #fff;
          font-size: 13px;

          i {
            font-size: 20px;
            margin-right: 5px;
          }
        }

        img {
          height: 20px;
        }
      }

      &-userInfo {
        img {
          border-radius: 50%;
          width: 24px;
          height: 24px;
        }

        &:hover {
          .jin-m-tabbar-return {
            z-index: 99;
            visibility: visible;
            top: 106%;
            opacity: 1;
          }
        }
      }

      &-return {
        background: #fff;
        padding: 6px 0;
        box-shadow: 0 2px 6px 0 rgba(34, 46, 80, 0.1);
        border-radius: 4px;
        color: #787b8a;
        position: absolute;
        top: 90%;
        right: 14px;
        transition: all 0.3s;
        visibility: hidden;
        opacity: 0;

        li {
          width: 120px;
          height: 36px;
          line-height: 35px;
          color: #3d4351;
          text-align: center;
        }
      }
    }

    &-popup {
      padding: 10px 18px;

      span {
        i {
          font-size: 18px;
          color: #3d4351;
        }
      }

      &-menu {
        margin-top: 16px;

        &-item {
          padding: 14px 0;
          display: flex;
          align-items: center;
          justify-content: space-between;

          p {
            font-size: 14px;
            color: #3d4351;
          }

          i {
            color: #787b8a;
            font-size: 12px;
          }
        }
      }
    }
  }
}

</style>
